import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const RedoIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 24, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        d="M 12 3.25 C 16.4626 3.25 20.1443 6.5902 20.6826 10.9072 C 20.8931 12.5954 20.753 13.7009 20.1133 15.2812 C 18.8158 18.4866 15.6733 20.75 12 20.75 C 7.5374 20.75 3.8557 17.4098 3.3174 13.0928 C 3.2662 12.6819 3.5579 12.3073 3.9688 12.2559 C 4.3798 12.2046 4.7544 12.4962 4.8057 12.9072 C 5.2515 16.4828 8.3034 19.25 12 19.25 C 15.0414 19.25 17.6476 17.3771 18.7236 14.7188 C 19.266 13.3788 19.3737 12.5308 19.1943 11.0928 C 18.7485 7.5172 15.6966 4.75 12 4.75 C 9.3695 4.75 7.0659 6.1516 5.7949 8.25 H 9 C 9.4142 8.25 9.75 8.5858 9.75 9 C 9.75 9.4142 9.4142 9.75 9 9.75 H 4 C 3.5858 9.75 3.25 9.4142 3.25 9 V 4 C 3.25 3.5858 3.5858 3.25 4 3.25 C 4.4142 3.25 4.75 3.5858 4.75 4 V 7.1006 C 6.3226 4.7779 8.9821 3.25 12 3.25 Z"
        fill={color}
      />
    </svg>
  ),
)

RedoIcon.displayName = 'RedoIcon'
